import Icon from 'veui/components/Icon'
import { IconLowSquare } from 'dls-icons-vue'

Icon.register('low-square', IconLowSquare)
